import React from "react"

import { connect } from "scrivito"
import { Room } from "shared/types/Room"
import { RowRendererProps } from "shared/ui/table/types"

import { ProductPositionTableRoomRow } from "./ProductPositionTableRoomRow"
import { useProductPositionTableRoomRowModel } from "./hooks/useProductPositionTableRoomRowModel"

function ProductPositionTableRoomRowConnectorComponent(
  props: RowRendererProps<Room>
) {
  return (
    <ProductPositionTableRoomRow
      {...useProductPositionTableRoomRowModel(props)}
    />
  )
}

export const ProductPositionTableRoomRowConnector = React.memo(
  connect(ProductPositionTableRoomRowConnectorComponent)
) as typeof ProductPositionTableRoomRowConnectorComponent
